// Hooks
import useMultiSite from './use-multi-site'

// Utils
import {categoryUrlBuilder, productUrlBuilder} from '@salesforce/retail-react-app/app/utils/url'
import {pageUrlBuilder} from '../utils/url-utils'

/**
 * Constructs a URL based on the specified link type and input URL.
 *
 * @param {string} urlToBuild - Should be a category id, product id, page id, or a full external url.
 * @param {string} linkType - The type of link to be constructed. This should be one of the
 *                            predefined constants in `LINK_TYPE`.
 * @returns {string} - The constructed URL based on the link type. Defaults to '#' if no valid link type is provided.
 */
export const useLinkUrl = (urlToBuild, linkType) => {
    const {buildUrl} = useMultiSite()

    let url = '#'

    switch (linkType) {
        case LINK_TYPE.CATEGORY:
            url = buildUrl(categoryUrlBuilder({id: urlToBuild}))
            break

        case LINK_TYPE.PRODUCT:
            url = buildUrl(productUrlBuilder({id: urlToBuild}))
            break

        case LINK_TYPE.PAGE_DESIGNER:
            url = buildUrl(pageUrlBuilder(urlToBuild))
            break

        case LINK_TYPE.EXTERNAL:
            if (!urlToBuild.startsWith('http')) {
                console.warn(
                    '[useLinkUrl] External urls should include a protocol, defaulting to https://'
                )
                urlToBuild = `https://${urlToBuild}`
            }
            url = urlToBuild
            break

        default:
            break
    }

    return url
}

export const LINK_TYPE = {
    CATEGORY: 'category',
    EXTERNAL: 'external',
    PAGE_DESIGNER: 'page-designer-page',
    PRODUCT: 'product'
}
